import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var LinkedInSVG = function LinkedInSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.13 2H3.87A1.87 1.87 0 002 3.87v24.26A1.87 1.87 0 003.87 30h24.26A1.87 1.87 0 0030 28.13V3.87A1.87 1.87 0 0028.13 2zM10.29 25.89H6.08V12.5h4.21zm-2.1-15.23a2.45 2.45 0 112.46-2.45 2.45 2.45 0 01-2.46 2.45zm17.72 15.23h-4.12v-6.48c0-1.57 0-3.5-2.2-3.5s-2.45 1.67-2.45 3.41V26H13V12.5h3.86v1.84H17a4.39 4.39 0 013.95-2.19c4.21 0 5 2.8 5 6.39z"
  }));
};
LinkedInSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LinkedInSVG);